import HomeCard from "../HomeCard";
import "./HomeCard5.css";

const HomeCard5 = () => {
    return <HomeCard className={"home-card-5"} itemType={"zepeto"} itemKey={0} itemName="젤괵이" itemDesc="소비자에게 한 걸음 더, 메타버스 브랜딩 아이템"/>
};

export default HomeCard5;
